import NumberFormat from 'react-number-format';
import ConfirmModal from '../../../../components/Modals/ConfirmModal';
import { useDispatch } from 'react-redux';
import { modalsToggle, snackShow } from '../../../../actions';
import { useAcceptAlternativeBidOfferMutation } from 'services/api/alternative-offers';

export const AcceptTopAlternativeOfferModal = ({ currentVehicle }: any) => {
  const dispatch = useDispatch();
  const [acceptAlternativeBidOffer] = useAcceptAlternativeBidOfferMutation();

  const handleSubmit = async () => {
    const response = await acceptAlternativeBidOffer(currentVehicle.id);
    if ('error' in response) {
      dispatch(snackShow({ type: 'error', message: 'Failed to accept' }));
    } else {
      dispatch(snackShow({ message: 'Offer accepted' }));
    }
    dispatch(modalsToggle(`acceptTopAlternativeOffer-${currentVehicle.id}`));
  };

  if (!currentVehicle.top_alternative_bid_offer) return null;

  return (
    <ConfirmModal
      submitText={'Accept'}
      modalId={`acceptTopAlternativeOffer-${currentVehicle.id}`}
      title={
        <>
          You are about to accept the offer of{' '}
          <NumberFormat
            displayType="text"
            prefix="$"
            value={currentVehicle.top_alternative_bid_offer.amount}
            thousandSeparator
          />{' '}
          from {currentVehicle.top_alternative_bid_offer.bidder?.dealership_name ?? ''}
        </>
      }
      handleSubmit={handleSubmit}
    />
  );
};
